import { Component } from '@angular/core';
// Ag-Grid
import { GridOptions, GridApi, ColDef, RowSelectionOptions } from 'ag-grid-community';
import { AgGridAngular } from 'ag-grid-angular';
import { DriversLicenseTableColumnDef } from './columnDefs';
import { agGridDarkTheme } from 'src/app/shared/components/ag-grid/dark-theme';
// Services
import { SharedService } from '../../services/shared.service';

// components
import { ModalID, ModalType } from '../../models/constants';
import { SelectBtnComponent } from '../../components/ag-grid/select-btn/select-btn.component';
import { DriverLicense } from '../../models/drivers-license-parser';

@Component({
    selector: 'app-drivers-license-selection',
    templateUrl: './drivers-license-selection.component.html',
    styleUrl: './drivers-license-selection.component.scss',
    standalone: true,
    imports: [AgGridAngular]
})
export class DriversLicenseSelectionComponent {
  public rowSelection: RowSelectionOptions = {
    mode: 'singleRow',
    enableSelectionWithoutKeys: false,
    checkboxes: false,
  };

  // ag-grid properties Grid
 gridApi!: GridApi
  
  columnDefs: ColDef[] = DriversLicenseTableColumnDef;
  defaultColDef;
  detailCellRendererParams: any;
  overlayLoadingTemplate;
  overlayNoRowsTemplate;
  gridOptions: GridOptions = {
    theme: agGridDarkTheme,};
  components: any;
  theme = agGridDarkTheme;

  constructor(public sharedService: SharedService) {
    this.gridOptions = <GridOptions>{};
    this.gridOptions.headerHeight = 50;
    this.gridOptions.rowHeight = 28;
    this.gridOptions.context = { ConfigComponent: this }; // this allows access to component functions
    this.gridOptions.rowClass = 'ag-grid-row';
    this.gridOptions.onFirstDataRendered = (params) => {
      this.applyFilters();
    };
    this.defaultColDef = {
      sortable: true,
      filter: true,
      resizable: true,
      floatingFilter: true,
      wrapHeaderText: true,
    };
    this.components = { SelectBtn: SelectBtnComponent };
  }
  onGridReady(params: any) {
    this.gridApi = params.api;
  }

  applyFilters() {
    const pending = this.sharedService.pending_4473?.transferee;
    const building = this.sharedService.dispo_build_selected_transferee_4473;

    let transferee = null;
    if (this.sharedService.pending_4473?._id && pending) {
      transferee = pending;
    } else if (building) {
      transferee = building;
    }

    if (transferee) {
      const filterModel: any = {};
      
      // The Name column is a valueGetter of First Name + Last Name Initial.
      // So filtering by the First Name is reliable.
      if (transferee.name_first) {
        filterModel.name = {
          filterType: 'text',
          type: 'contains',
          filter: transferee.name_first.trim(),
        };
      }

      // Birthdate format in the table might be MM-DD-YYYY or YYYY-MM-DD. 
      // We'll use a contains filter for the year as it's the safest bet.
      if (transferee.birth_year) {
        filterModel.birthDate = {
          filterType: 'text',
          type: 'contains',
          filter: transferee.birth_year,
        };
      }

      if (Object.keys(filterModel).length > 0) {
        setTimeout(() => {
          this.gridApi.setFilterModel(filterModel);
        }, 100);
      }
    }
  }

  ngOnInit(): void {
    this.addButtonColumn();
   // this.insertData();
   this.sharedService.getRecentDriverLicenses();
  }
  addButtonColumn() {
    const hasSelect = this.columnDefs.some(
      (column) => column.headerName === 'Select ID'
    );
    if (!hasSelect) {
      this.columnDefs.push({
        headerName: 'Select ID',
        resizable: true,
        width: 150,
        pinned: 'right',
        cellRenderer: 'SelectBtn',
        cellRendererParams: {
          selectItemClick: this.selectIDClick.bind(this),
        },
      });
    }
  }
  selectIDClick(params) {
    this.sharedService.parsed_license = params['colValues'] as DriverLicense;
    if (!this.sharedService.dispo_build_modal_shown) {
      this.sharedService.drivers_license_id_selected$.next(
        params['colValues']['driversId']
      );
      this.sharedService.closeModal(ModalID.drivers_license_selection);
    } else {
      this.sharedService.closeModal(ModalID.dispo_build);
      this.sharedService.dispo_build_selected_drivers_license = params[
        'colValues'
      ] as DriverLicense;
      this.sharedService.build_disposition.buyers_drivers_license =  params[
        'colValues'
      ] as DriverLicense;
       this.sharedService.drivers_license_id_selected$.next(
        params['colValues']['driversId']
      );
    }
  }
  closeComponent() {
    if (this.sharedService.dispo_build_modal_shown) {
      this.sharedService.closeModal(ModalID.dispo_build);
      setTimeout(() => {
        this.sharedService.dispo_build_modal_shown = false;
      }, 200);
    } else {
      this.sharedService.closeModal(ModalID.drivers_license_selection);
    }
  }
  insertData() {
    if (this.sharedService.recent_drivers_license.length === 0) {
      // this.sharedService.recent_drivers_license.push(
      //   {
      //     driversId: 'D1234567',
      //     nameLast: 'Doe',
      //     nameFirst: 'John',
      //     nameMiddle: 'A',
      //     expirationDate: '2025-01-01',
      //     issueDate: '2020-01-01',
      //     birthDate: '1980-01-01',
      //     gender: 'Male',
      //     eyeColor: 'Blue',
      //     hairColor: 'Brown',
      //     height_ft: '5',
      //     height_in: '10',
      //     weight: '180',
      //     addressStreet: '123 Main St',
      //     addressCity: 'Anytown',
      //     addressState: 'CA',
      //     addressPostalCode: '12345',
      //     documentDiscriminator: '123456789',
      //     country: 'USA',
      //     nameLastTruncation: 'None',
      //     nameFirstTruncation: 'None',
      //     nameMiddleTruncation: 'None',
      //     auditInformation: 'Audit123',
      //     inventoryControlNumber: 'ICN123',
      //     turnsEighteen: '1998-01-01',
      //     turnsTwentyOne: '2001-01-01',
      //     complianceType: 'Compliant',
      //     organDonor: 'Yes',
      //     cardRevisionDate: '2020-01-01',
      //     specificVehicleClass: 'Class C',
      //     drivingPrivileges: 'Full',
      //     endorsementCodes: 'None',
      //     licenseNumber: 'L1234567',
      //     vehicleClass: 'Class C',
      //     restrictionCodes: 'None',
      //   },
      //   {
      //     driversId: 'D2345678',
      //     nameLast: 'Smith',
      //     nameFirst: 'Jane',
      //     nameMiddle: 'B',
      //     expirationDate: '2026-02-02',
      //     issueDate: '2021-02-02',
      //     birthDate: '1985-02-02',
      //     gender: 'Female',
      //     eyeColor: 'Green',
      //     hairColor: 'Blonde',
      //     height_ft: '5',
      //     height_in: '6',
      //     weight: '140',
      //     addressStreet: '456 Elm St',
      //     addressCity: 'Othertown',
      //     addressState: 'TX',
      //     addressPostalCode: '67890',
      //     documentDiscriminator: '987654321',
      //     country: 'USA',
      //     nameLastTruncation: 'None',
      //     nameFirstTruncation: 'None',
      //     nameMiddleTruncation: 'None',
      //     auditInformation: 'Audit456',
      //     inventoryControlNumber: 'ICN456',
      //     turnsEighteen: '2003-02-02',
      //     turnsTwentyOne: '2006-02-02',
      //     complianceType: 'Compliant',
      //     organDonor: 'No',
      //     cardRevisionDate: '2021-02-02',
      //     specificVehicleClass: 'Class C',
      //     drivingPrivileges: 'Full',
      //     endorsementCodes: 'None',
      //     licenseNumber: 'L2345678',
      //     vehicleClass: 'Class C',
      //     restrictionCodes: 'None',
      //   },
      //   {
      //     driversId: 'D3456789',
      //     nameLast: 'Johnson',
      //     nameFirst: 'Alice',
      //     nameMiddle: 'C',
      //     expirationDate: '2027-03-03',
      //     issueDate: '2022-03-03',
      //     birthDate: '1990-03-03',
      //     gender: 'Female',
      //     eyeColor: 'Brown',
      //     hairColor: 'Black',
      //     height_ft: '5',
      //     height_in: '4',
      //     weight: '130',
      //     addressStreet: '789 Oak St',
      //     addressCity: 'Sometown',
      //     addressState: 'FL',
      //     addressPostalCode: '34567',
      //     documentDiscriminator: '456789123',
      //     country: 'USA',
      //     nameLastTruncation: 'None',
      //     nameFirstTruncation: 'None',
      //     nameMiddleTruncation: 'None',
      //     auditInformation: 'Audit789',
      //     inventoryControlNumber: 'ICN789',
      //     turnsEighteen: '2008-03-03',
      //     turnsTwentyOne: '2011-03-03',
      //     complianceType: 'Compliant',
      //     organDonor: 'Yes',
      //     cardRevisionDate: '2022-03-03',
      //     specificVehicleClass: 'Class C',
      //     drivingPrivileges: 'Full',
      //     endorsementCodes: 'None',
      //     licenseNumber: 'L3456789',
      //     vehicleClass: 'Class C',
      //     restrictionCodes: 'None',
      //   },
      //   {
      //     driversId: 'D4567890',
      //     nameLast: 'Brown',
      //     nameFirst: 'Bob',
      //     nameMiddle: 'D',
      //     expirationDate: '2028-04-04',
      //     issueDate: '2023-04-04',
      //     birthDate: '1975-04-04',
      //     gender: 'Male',
      //     eyeColor: 'Hazel',
      //     hairColor: 'Gray',
      //     height_ft: '6',
      //     height_in: '2',
      //     weight: '200',
      //     addressStreet: '101 Pine St',
      //     addressCity: 'Anycity',
      //     addressState: 'NY',
      //     addressPostalCode: '45678',
      //     documentDiscriminator: '789123456',
      //     country: 'USA',
      //     nameLastTruncation: 'None',
      //     nameFirstTruncation: 'None',
      //     nameMiddleTruncation: 'None',
      //     auditInformation: 'Audit012',
      //     inventoryControlNumber: 'ICN012',
      //     turnsEighteen: '1993-04-04',
      //     turnsTwentyOne: '1996-04-04',
      //     complianceType: 'Compliant',
      //     organDonor: 'No',
      //     cardRevisionDate: '2023-04-04',
      //     specificVehicleClass: 'Class C',
      //     drivingPrivileges: 'Full',
      //     endorsementCodes: 'None',
      //     licenseNumber: 'L4567890',
      //     vehicleClass: 'Class C',
      //     restrictionCodes: 'None',
      //   },
      //   {
      //     driversId: 'D5678901',
      //     nameLast: 'Davis',
      //     nameFirst: 'Charlie',
      //     nameMiddle: 'E',
      //     expirationDate: '2029-05-05',
      //     issueDate: '2024-05-05',
      //     birthDate: '2000-05-05',
      //     gender: 'Male',
      //     eyeColor: 'Blue',
      //     hairColor: 'Red',
      //     height_ft: '5',
      //     height_in: '8',
      //     weight: '170',
      //     addressStreet: '202 Maple St',
      //     addressCity: 'Newtown',
      //     addressState: 'IL',
      //     addressPostalCode: '56789',
      //     documentDiscriminator: '012345678',
      //     country: 'USA',
      //     nameLastTruncation: 'None',
      //     nameFirstTruncation: 'None',
      //     nameMiddleTruncation: 'None',
      //     auditInformation: 'Audit345',
      //     inventoryControlNumber: 'ICN345',
      //     turnsEighteen: '2018-05-05',
      //     turnsTwentyOne: '2021-05-05',
      //     complianceType: 'Compliant',
      //     organDonor: 'Yes',
      //     cardRevisionDate: '2024-05-05',
      //     specificVehicleClass: 'Class C',
      //     drivingPrivileges: 'Full',
      //     endorsementCodes: 'None',
      //     licenseNumber: 'L5678901',
      //     vehicleClass: 'Class C',
      //     restrictionCodes: 'None',
      //   }
      // );
    }
  }
}
